import { Ping } from "@certa/icons/components/Ping";

import type { Header } from "../../Table.types";

import styles from "../InternalTableHeader.module.css";

type InternalTableHeaderPinnerProps<TableData> = {
  header: Header<TableData, unknown>;
  onToggleColumnPin?: (columnId: string, isPinned: boolean) => void;
};

export const InternalTableHeaderPinner = <
  TableData extends Record<string, any>
>(
  props: InternalTableHeaderPinnerProps<TableData>
) => {
  const { header, onToggleColumnPin } = props;

  const canPin = header.column.getCanPin();

  if (!canPin) {
    return null;
  }

  const onTogglePin = () => {
    const currentPinnedStatus = header.column.getIsPinned();
    if (currentPinnedStatus === "left") {
      header.column.pin(false);
      onToggleColumnPin?.(header.column.id, false);
    } else {
      header.column.pin("left");
      onToggleColumnPin?.(header.column.id, true);
    }
  };

  return (
    <button className={styles.tableColumnPinIcon} onClick={onTogglePin}>
      <Ping size={12} />
    </button>
  );
};
